import { render, staticRenderFns } from "./BuilderLayout.vue?vue&type=template&id=f2ee98b6&"
import script from "./BuilderLayout.vue?vue&type=script&lang=ts&"
export * from "./BuilderLayout.vue?vue&type=script&lang=ts&"
import style0 from "./BuilderLayout.vue?vue&type=style&index=0&id=f2ee98b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports